module.exports = __webpack_public_path__ + "img/farmart.b3a471d3.png";